import styled from "styled-components";

export const ButtonWrapper = styled.div`
  margin-top: 24px;
  border-top: 1px solid #e5e7eb;
  padding-top: 24px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 16px;

  @media (max-width: 768px) {
    align-items: center;
    justify-content: flex-start;
  }

  @media (max-width: 425px) {
    align-items: center;
    flex-direction: column-reverse;
    gap: 12px;

    button {
      min-width: 160px;
    }
  }
`;
